// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__328A-","content":"LayoutSettings_content__2lZQF"};